import { Box } from '@mui/material';
import { RenderTable } from '../../../../components/ui';
import THead from './THead';
import TBody from './TBody';
interface IProps {
  moduleData: any;
  isView: boolean;
}

const TController = ({ moduleData, isView }: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            moduleData,
            isView,
          }}
        />
        <TBody
          {...{
            moduleData,
            isView,
          }}
        />
      </RenderTable>
    </Box>
  );
};

export default TController;
